var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { postJson, putJson, withDone, withValidate, withMap, deleteJson } from '@rad/utility/http';
import { arrayBufferToBase64, getMimeTypeFromFilename } from '@rad/utility/formatting';
import { defaultVariant, headerVariant, isImage, sizeVariantSrcSet, zoomedCopy } from '../../types';
import { BLOB_BASE } from '../constants';
const fileToSerializable = (file, sortOrder) => __awaiter(void 0, void 0, void 0, function* () {
    const buffer = yield file.arrayBuffer();
    return {
        name: file.name,
        size: file.size,
        contentType: getMimeTypeFromFilename(file.name),
        contentBase64: arrayBufferToBase64(buffer),
        sortOrder,
    };
});
const filesToSerializable = (files, sortStart) => __awaiter(void 0, void 0, void 0, function* () { return Promise.all(files.map((f, i) => fileToSerializable(f, sortStart + i + 1))); });
export const serializeFile = (file) => fileToSerializable(file, 0);
export const map = (x) => x.map((a) => (Object.assign(Object.assign({}, a), { url: `${BLOB_BASE}/${a.storagePath}` })));
/** A photo as its frames show it, from its asset: the original, with its smaller copies as a srcSet
 *  and its zoomed copies when its crop zooms in (PhotoFrame). Undefined for an asset with no image. */
export const photoOfAsset = (dto) => {
    const asset = { id: dto.id, attachments: map(dto.attachments) };
    const original = defaultVariant(asset);
    return original !== undefined && isImage(original)
        ? Object.assign(Object.assign(Object.assign({}, original), { srcSet: sizeVariantSrcSet(asset) }), zoomedCopy(asset)) : undefined;
};
/** The photos of `dtos` that are images, in order. */
export const photosOfAssets = (dtos) => dtos.flatMap(dto => { var _a; return (_a = photoOfAsset(dto)) !== null && _a !== void 0 ? _a : []; });
/** What a banner shows of a photo: its header copy, cut for banners, else the photo itself. */
export const bannerUrl = (dto) => {
    var _a, _b;
    const header = headerVariant({ id: dto.id, attachments: map(dto.attachments) });
    return (_a = header === null || header === void 0 ? void 0 : header.url) !== null && _a !== void 0 ? _a : (_b = photoOfAsset(dto)) === null || _b === void 0 ? void 0 : _b.url;
};
export const create = (kind, files, sortStart) => __awaiter(void 0, void 0, void 0, function* () {
    const fs = yield filesToSerializable(files, sortStart);
    return withDone(withValidate(withMap(postJson(`/api/attachments`, { kind, files: fs }), map)))();
});
export const update = (f, propertyId) => withDone(withValidate(putJson(`/api/attachments`, Object.assign(Object.assign({}, f), { propertyId }))))();
export const setHeaderVariant = (assetId, attachmentId) => withDone(withValidate(withMap(postJson(`/api/attachments/set-header`, { assetId, attachmentId }), (a) => map([a])[0])))();
/** Saves a photo's crop; answers it as saved, with the zoomed copies the server made for it. */
export const setFocus = (id, crop) => withDone(withValidate(withMap(putJson(`/api/attachments/${id}/focus`, crop), (saved) => {
    const copies = zoomedCopy({ attachments: map(saved.zoomedCopies) });
    return Object.assign(Object.assign({}, crop), { zoomedUrl: copies === null || copies === void 0 ? void 0 : copies.zoomedUrl, zoomedSrcSet: copies === null || copies === void 0 ? void 0 : copies.zoomedSrcSet });
})))();
export const softDelete = (f) => withDone(withValidate(deleteJson(`/api/attachments`, f)))();
export const uploadFile = (file, kind) => __awaiter(void 0, void 0, void 0, function* () {
    const [success, result] = yield create(kind, [file], 0);
    if (success) {
        return { id: result[0].id, url: `${BLOB_BASE}/${kind}/${result[0].id}` };
    }
    return null;
});
